import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { AbstractFormDialog } from '../../dialog/abstract-form-dialog'
import { Observable } from 'rxjs'
import {
	MatDialogActions,
	MatDialogClose,
	MatDialogContent,
	MatDialogRef,
	MatDialogTitle,
} from '@angular/material/dialog'
import { AuthService } from '../../../modules/auth/auth.service'
import { map, switchMap } from 'rxjs/operators'
import { AppUser } from '../../../../../domain/user/app-user.model'
import { LoadingService } from '../../../core/services/loading.service'
import { ReactiveFormsModule } from '@angular/forms'
import { FmxFormSubmitDirective } from '../../modules/form/submit/form-submit.directive'
import { SellerOrderConfirmationFormComponent } from './seller-order-confirmation-form.component'
import { FmxControlSubmitDirective } from '../../modules/form/submit/control-submit.directive'
import { AsyncPipe, NgIf } from '@angular/common'
import { MatError } from '@angular/material/select'
import { MatButton } from '@angular/material/button'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
	selector: 'app-seller-order-confirmation-dialog',
	template: `
		<form [formGroup]="form" (fmxSubmit)="onSubmit()">
			<h2 matDialogTitle>Confirma</h2>

			<mat-dialog-content>
				<app-seller-order-confirmation-form formControlName="model"></app-seller-order-confirmation-form>
				<mat-error *ngIf="errors$ | async as errors" class="mb-3">{{ errors }}</mat-error>
			</mat-dialog-content>

			<div mat-dialog-actions>
				<button mat-button mat-dialog-close class="btn-custom-default">{{ 'actiune.inchide' | translate }}</button>
				<button
					mat-raised-button
					type="submit"
					color="primary"
					class="btn-custom-primary"
					[disabled]="loadingService.loading$ | async"
				>
					Confirma
				</button>
			</div>
		</form>
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		ReactiveFormsModule,
		FmxFormSubmitDirective,
		MatDialogTitle,
		MatDialogContent,
		SellerOrderConfirmationFormComponent,
		FmxControlSubmitDirective,
		NgIf,
		MatError,
		MatDialogActions,
		MatButton,
		MatDialogClose,
		AsyncPipe,
		TranslatePipe,
	],
})
export class SellerOrderConfirmationDialog extends AbstractFormDialog<AppUser, SellerOrderConfirmationDialog> {
	protected readonly dialogRef: MatDialogRef<SellerOrderConfirmationDialog>
	private readonly authService = inject<AuthService>(AuthService)
	readonly loadingService: LoadingService

	seller_found: any

	constructor() {
		const dialogRef = inject<MatDialogRef<SellerOrderConfirmationDialog>>(MatDialogRef)
		const loadingService = inject<LoadingService>(LoadingService)

		super(dialogRef, loadingService)

		this.dialogRef = dialogRef
		this.loadingService = loadingService
	}

	protected initialFormValue(): any {
		return {}
	}

	protected action$(model: AppUser): Observable<unknown> {
		return this.authService.appUser$.pipe(
			switchMap((appUser) => {
				this.seller_found = { uid: appUser?.uid, name: appUser?.name }
				return this.authService
					.signInWithEmailAndPassword(appUser?.email as string, model.password)
					.pipe(map((user) => appUser))
			}),
		)
	}

	protected getErrorMessage(err: unknown, model: AppUser): any {
		return { status: `Utilizatorul sau parola sunt gresite!`, seller: null }
	}

	protected getSuccessMessage(model: AppUser): any {
		return { status: 'success', seller: this.seller_found }
	}
}
